import { withStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  DialogActions,
  Button,
  IconButton,
} from "@material-ui/core";
import { compose } from "recompose";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { withSnackbar } from "notistack";
import { postData } from "../../../../../api/componentAPIs";

const styles = (theme) => ({
  root: {
    padding: "8px 12px",
    verticalAlign: "middle",
    height: "100%",
    color: theme.gridIconBorderColor,
    "&$checked": {
      color: theme.HeaderSelectedText,
    },
  },
  label: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
  },
  checked: {
    color: theme.HeaderSelectedText,
  },
  dialog: {
    padding: "18px 24px",
    boxSizing: "border-box",
    borderRadius: "2px",
    backgroundColor: theme.ModalBGColor,
    boxShadow: "2px 2px 4px black",
    width: 400,
    userSelect: "none",
  },
  dialogTitle: {
    fontSize: theme.headerTextFontSize,
    fontWeight: "600",
    lineHeight: "20px",
    color: "#D03131",
    padding: 0,
  },
  dialogContent: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    overflow: "hidden",
    padding: "16px 0px",
  },
  redButton: {
    fontSize: theme.headerTextFontSize,
    textTransform: "none",
    borderRadius: "2px",

    margin: 0,
    width: "47%",
    background: "#D03131",
    color: theme.ModalBGColor,
  },
  button: {
    fontSize: theme.headerTextFontSize,
    textTransform: "none",
    borderRadius: "2px",

    margin: 0,
    width: "47%",
  },
  dialogAction: {
    justifyContent: "space-between",
    margin: 0,
    "&$actionButton": {
      paddingBottom: 0,
      paddingRight: 0,
    },
  },
  actionButton: {
    margin: 0,
    padding: 0,
    display: "flex",
    justifyContent: "space-between",
  },
  closeButton: { color: theme.iconColor, padding: "0px 10px" },
  dialogTitlestyle: {
    padding: 0,
    height: "20px",
  },
});

const CancelDispatchModal = ({
  data,
  userData,
  classes,
  eventHub,
  onClose,
  enqueueSnackbar,
}) => {
  const cancelDispatch = () => {
    eventHub.emit("DispatchEvents", "ShowLoaderDialog", [
      "Dispatch cancellation",
    ]);
    postData("CancelDispatch", {
      dispatchId: data.dispatchId,
      driverId: data.driverId,
      eventDateTime: new Date(),
      userId: userData.userProfile.userId,
      terminalCode: userData.userProfile.terminal.code,
    }).then((response) => {
      if (response && Math.trunc(response.status / 100) === 2) {
        onClose();
      } else {
        enqueueSnackbar(`Failed to cancel dispatch`, {
          variant: "error",
        });
        eventHub.emit("DispatchEvents", "HideLoaderDialog", []);
      }
    });
  };

  return (
    <Dialog
      open={true}
      aria-labelledby="CancelDispatch-title"
      classes={{ paper: classes.dialog }}
      maxWidth="sm"
    >
      <DialogTitle
        id="CancelDispatch-title"
        classes={{ root: classes.dialogTitlestyle }}
        disableTypography
      >
        <Grid container item lg={12} md={12} xs={12}>
          <Grid item md={11} xs={10}>
            <span className={classes.dialogTitle}>Cancel Dispatch</span>
          </Grid>
          <Grid item md={1} xs={2} className={classes.closeIcon}>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        <Grid container spacing={24}>
          <Grid item xs={12} classes={{ root: classes.message }}>
            Are you sure you want to cancel Dispatch action?
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <Grid container spacing={24}>
          <Grid item xs={4}></Grid>
          <Grid item xs={8} classes={{ item: classes.actionButton }}>
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              className={classes.button}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              size="small"
              disableRipple
              className={classes.redButton}
              onClick={cancelDispatch}
            >
              Confirm
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default compose(
  withUserProfile,
  withSnackbar,
  withStyles(styles)
)(CancelDispatchModal);
